import { API } from '@aws-amplify/api'

import {
  addCalendarData,
  addAvailabilityData,
  calendarError,
  calendarSuccess,
  addHolidayData,
  addHolidayResponse,
  editHolidayResponse,
  deleteHolidayResponse,
  updateHolidayDataInProgress,
  deleteSettingsData,
} from '../actions'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'

interface CalendarGetRequest {
  user_id: string | null | string[]
  startdate: string
  enddate: string
}

interface UserAvailabilityRequest {
  startdate: string
  enddate: string
}

interface CalendarUpdateRequest {
  user_id: string | null | string[]
  timeoffDates: string[]
  start_date: string
  end_date: string
}

const CALENDAR_API_NAME = '/user-management/calendar'

// TODO: Move to helper function

export const fetchCalendarData =
  ({ user_id, startdate, enddate }: CalendarGetRequest) =>
  async (dispatch) => {
    if (!user_id || user_id instanceof Array) return
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          startdate: startdate,
          enddate: enddate,
        },
      }

      const result = await API.get(WOMA_API_GATEWAY_NAME, `${CALENDAR_API_NAME}/time-off/${user_id}`, options)
      if (result?.user_id === user_id && result?.date_off) {
        const uniqueSet = new Set(result.date_off)
        dispatch(addCalendarData({ payload: [...uniqueSet], user_id }))
      }
    } catch (error) {
      dispatch(calendarError({ message: 'Unable to fetch calendar data' }))
      console.log('Calendar Error', error)
    }
  }

export const updateCalendarData =
  ({ user_id, timeoffDates, start_date, end_date }: CalendarUpdateRequest) =>
  async (dispatch) => {
    if (!user_id || user_id instanceof Array) return

    try {
      const options = {
        headers: {},
        response: false,
        body: {
          user_id,
          start_date,
          end_date,
          date_off: timeoffDates,
        },
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${CALENDAR_API_NAME}/time-off/${user_id}`, options)

      dispatch(addCalendarData({ payload: timeoffDates, user_id }))
      dispatch(calendarSuccess({ successMessage: 'Calendar updated successfully' }))
      // Make a get call after saving the data
      // const getCalendarOptions = {
      //   headers: {},
      //   response: false,
      //   queryStringParameters: {
      //     startdate: start_date,
      //     enddate: end_date,
      //   },
      // }

      // const getCalendarResults = await API.get(
      //   WOMA_API_GATEWAY_NAME,
      //   `/user-management/${CALENDAR_API_NAME}/${user_id}`,
      //   getCalendarOptions,
      // )

      // dispatch(addCalendarData({ payload: result.date_off, user_id }))

      // if (getCalendarResults?.user_id === user_id && result?.date_off) {
      //   dispatch(addCalendarData({ payload: result.date_off, user_id }))
      // }
    } catch (error) {
      dispatch(calendarError({ message: 'Error: Uploading the data' }))
      console.log('Calendar Error', error)
    }
  }

export const getAvailablePathologist =
  ({ startdate, enddate }: UserAvailabilityRequest) =>
  async (dispatch) => {
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          startdate: startdate,
          enddate: enddate,
        },
      }

      const result = await API.get(WOMA_API_GATEWAY_NAME, `${CALENDAR_API_NAME}`, options)

      dispatch(addAvailabilityData({ payload: result }))
    } catch (error) {
      console.log('Calendar Error', error)
    }
  }

export const closeCalendarAlertError = () => async (dispatch) => {
  dispatch(calendarError({ message: '' }))
}

export const closeCalendarAlertSuccess = () => async (dispatch) => {
  dispatch(calendarSuccess({ successMessage: '' }))
}

export const getHolidayData = () => async (dispatch) => {
  const apiName = '/settings/holiday'
  try {
    const options = {
      headers: {},
      response: false,
    }

    const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}`, options)

    if (result) {
      dispatch(addHolidayData({ payload: result }))
    }
    dispatch(updateHolidayDataInProgress({ inProgress: true }))
  } catch (err) {
    console.log('getHolidayData Error', err)
  } finally {
    dispatch(updateHolidayDataInProgress({ inProgress: false }))
  }
}

export const AddHolidayDataSettings =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/settings/holiday'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'ADD_HOLIDAY_SUCCESS'
    } catch (err) {
      action = 'ADD_HOLIDAY_SUCCESS'
      console.log('AddHolidayDataSettings Error', err)
    } finally {
      dispatch(addHolidayResponse({ action: action }))
    }
  }

export const EditHolidayDataSettings =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/settings/holiday'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'EDIT_HOLIDAY_SUCCESS'
    } catch (err) {
      action = 'EDIT_HOLIDAY_ERROR'
      console.log('EditHolidayDataSettings Error', err)
    } finally {
      dispatch(editHolidayResponse({ action: action }))
    }
  }

export const DeleteHolidayDataSettings =
  ({ payload }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/settings/holiday'
    try {
      const options = {
        headers: {},
        response: false,
        body: payload,
      }
      const result = await API.del(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      action = 'DELETE_HOLIDAY_SUCCESS'
    } catch (err) {
      action = 'DELETE_SETTING_ERROR'
      console.log('DeleteHolidaySettings Error', err)
    } finally {
      dispatch(deleteHolidayResponse({ action: action }))
    }
  }
